"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrescentResearchAssociation = void 0;
const CardName_1 = require("../../CardName");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
class CrescentResearchAssociation extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.CRESCENT_RESEARCH_ASSOCIATION,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MOON],
            startingMegaCredits: 50,
            metadata: {
                description: 'You start with 50 M€.',
                cardNumber: 'MC5',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(50);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When you play a moon tag, you pay 1 M€ less for each Moon tag you have.', (eb) => {
                            eb.moon().startEffect.megacredits(-1).slash().moon();
                        });
                        ce.vSpace();
                        ce.vSpace();
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                    b.vpText('1 VP for every 3 Moon tags you have.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.moon(1, 3),
            },
        });
    }
    play() {
        return undefined;
    }
    getCardDiscount(player, card) {
        if (card.tags.indexOf(Tags_1.Tags.MOON) === -1) {
            return 0;
        }
        return player.getTagCount(Tags_1.Tags.MOON);
    }
    getVictoryPoints(player) {
        return Math.floor(player.getTagCount(Tags_1.Tags.MOON, 'raw') / 3);
    }
}
exports.CrescentResearchAssociation = CrescentResearchAssociation;
//# sourceMappingURL=CrescentResearchAssociation.js.map